import {Inject, ISimpleControllerConfiguration, SimpleBaseController,} from "@denishussar/html5-game-engine";
import {LockCellModel} from "../Models/LockCellModel";
import {LockCellController} from "./LockCellController";
import {MiniGameTypeEnum} from "../../../../../Models/Game/MiniGameModel";
import {GameLogic} from "../../../../../Logic/GameLogic";

export interface IRootControllerOptions {
}

export class RootController extends SimpleBaseController {
    $model: LockCellModel;

    public constructor(
        @Inject private _options: IRootControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super("RootController");
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        return {
            childControllers: {
                LoanController: {
                    view: LockCellController,
                    model: this.$model,
                    options: {
                        onComplete: () => this._gameLogic.onMiniGameComplete(MiniGameTypeEnum.lock_cell)
                    }
                },
            },
        };
    }

    protected onInitialize(): void {
    }

    protected onLandscape(): void {
    }

    protected onPortrait(): void {
    }
}
